import React, { useState } from 'react';
import { GlobeIcon } from 'lucide-react';
interface LanguageSwitcherProps {
  className?: string;
}
export function LanguageSwitcher({
  className = ''
}: LanguageSwitcherProps) {
  const [currentLanguage, setCurrentLanguage] = useState<'de' | 'en'>('de');
  const handleLanguageChange = (lang: 'de' | 'en') => {
    setCurrentLanguage(lang);
    // Here you would typically integrate with i18n library
    // For now, we'll just update the state
    console.log(`Language changed to: ${lang}`);
  };
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-146">
      <GlobeIcon className="w-4 h-4 text-gray-400" data-id="element-147" />
      <div className="flex items-center gap-1" data-id="element-148">
        <button onClick={() => handleLanguageChange('de')} className={`px-2 py-1 text-sm font-medium transition-colors rounded ${currentLanguage === 'de' ? 'text-white' : 'text-gray-500 hover:text-gray-300'}`} data-id="element-149">
          DE
        </button>
        <span className="text-gray-600" data-id="element-150">|</span>
        <button onClick={() => handleLanguageChange('en')} className={`px-2 py-1 text-sm font-medium transition-colors rounded ${currentLanguage === 'en' ? 'text-white' : 'text-gray-500 hover:text-gray-300'}`} data-id="element-151">
          EN
        </button>
      </div>
    </div>;
}